// extracted by mini-css-extract-plugin
export default {"uikit-image":"uikit-image__6Ozz8","uikit-image--accessory":"uikit-image--accessory__YUlsa","uikit-image--context":"uikit-image--context__-e1v1"};